import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import NpvrSlider, { NpvrSliderItem } from './npvr-slider';
import { rootStore } from './_stores/store-root';
import { mapNpvrEventToCardProps } from '@smart-tv/utils/kmm/helpers';
import { useToast, IconTypes } from '@smart-tv/hooks/use-toast/use-toast';
import useDelayedSpinner from '@smart-tv/hooks/use-delayed-spinner/use-delayed-spinner';
import NpvrLoading from './npvr-loading';

export const NpvrErrors: React.FC = observer(() => {
  const { data: failedEvents } = rootStore.npvrStore.failed;
  const { showToast } = useToast();
  const showSpinner = useDelayedSpinner(failedEvents === undefined);

  const assetPressHandler = () =>
    showToast('Programmet kan ikke afspilles herfra, da det ikke er optaget ', IconTypes.info);

  useEffect(() => {
    rootStore.npvrStore.fetchFailed().catch((error) => console.error(error));
  }, []);

  const displayString =
    failedEvents?.length === 0
      ? 'Du har ingen fejlede optagelser.'
      : 'Der skete desværre fejl under følgende optagelser, så de ikke er tilgænglige. Udsendelserne kan eventuelt findes via arkivet.';

  if (showSpinner) return <NpvrLoading />;
  if (failedEvents === undefined) return null;

  const sliderItems: NpvrSliderItem[] = failedEvents.map((event) => ({
    ...mapNpvrEventToCardProps(event, false),
    expiryLabel: undefined
  }));

  return (
    <>
      <NpvrSlider
        items={sliderItems}
        displayString={displayString}
        assetPressHandler={assetPressHandler}
      />
    </>
  );
});

export default NpvrErrors;
